<template>
  <div class="index">
    <div class="top">
      <div>
        <p class="phone" @click="updateMobile">{{ userPhone }}</p>
        <p class="label">欢迎您，{{ userNo }}</p>
      </div>
      <!-- <div class="vip"><img :src="topImg" /></div> -->
    </div>
    <div class="topbutton">
      <div class="left">
        <van-button
          round
          class="disable"
          style="width: 90px"
          @click="couponsHandle"
          >可用礼券</van-button
        >
        <van-button round style="width: 90px">已用礼券</van-button>
        <van-button
          round
          class="disable"
          @click="$push({ path: '/orders?type=-1' })"
          >订单</van-button
        >
        <van-button round class="disable" @click="$push({ path: '/withdrawList?type=-1' })">提现</van-button>
      </div>
    </div>
    <!-- <LoadingModal /> -->
    <!-- <Header :show="true" :isShadow="false" title="已用礼券" /> -->
    <div class="couponList">
      <div class="orderList">
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          :immediate-check="false"
          :offset="1"
          ref="vanList"
        >
          <ListItem
            v-for="(item, index) in list"
            :key="index"
            :itemData="item"
            class="isModal"
          />
        </van-list>
        <!-- <van-overlay
          z-index="1002"
          :show="showDetail"
          @click="showDetail = false"
        >
          <div class="pageFlexColumn itemModal" v-if="showDetail">
            <ListItem :itemData="orderInfo" class="isModal" :show="false" />
            <div
              class="pageBgBlock pageBannarShadow radios"
              @click="showDetail = !showDetail"
            >
              关闭
            </div>
          </div>
        </van-overlay> -->
      </div>
      <van-empty image="search" :description="finishText" v-if="tips" />
    </div>
  </div>
</template>
<script>
import { getUsedCoupons } from "api/user";
import ListItem from "./UsedCouponsItem";
export default {
  components: {
    ListItem,
  },
  data() {
    return {
      list: [],
      loading: true,
      finished: false,
      currentPages: 1,
      len: 0,
      finishText: "",
      className: "",
      result: true,
      tips: false,
      userPhone: "",
      userNo: "",
      // isShow: false,
      // bgImg: require("assets/code.png"),
      // // 详情
      // selItem: { name: 2 },
      // showDetail: false,
      // orderInfo: {},
      // selectStatus: -1,
    };
  },
  mounted() {
    this.list = [];
    this.getList();
  },
  methods: {
    getList() {
      this.finishText = "";
      this.list = [];
      this.currentPages = 1;
      this.len = 0;
      this.finished = false;
      this.loading = true;
      this.tips = false;
      this.userPhone = this.$route.query.userPhone;
      this.userNo = this.$route.query.userNo;
      this.onLoad();
    },
    onLoad() {
      if (this.result) {
        this.result = false;
        setTimeout(async () => {
          if (this.currentPages == 1) {
            this.list = [];
          }
          getUsedCoupons(this.currentPages).then((res) => {
            if (res.status == 200) {
              this.result = true;
              this.len += res.data.records.length; // 10
              for (let i = 0; i < res.data.records.length; i++) {
                this.list.push(res.data.records[i]);
              }
              if (this.len >= res.data.total || res.data.records == []) {
                this.finished = true;
                this.tips = false;
              }
              this.loading = false;
              this.currentPages++;
            } else {
              this.result = true;
              this.finished = true;
            }
            if (this.list.length <= 0) {
              this.className = "";
              this.finishText = "暂无已用礼券";
              this.tips = true;
            }
            this.$nextTick(function () {
              this.isShow = true;
              this.$store.commit("setPageLoading", false);
            });
          });
        }, 500);
      }
    },
    couponsHandle() {
      // this.$push({
      //                   path: "/index",
      //                   query: {
      //                       count: this.$route.query.count,
      //                       id: this.$route.query.id,
      //                       couponsMouldId: this.$route.query.couponsMouldId,
      //                       couponsUpstreamId: this.$route.query.couponsUpstreamId,
      //                       couponsBuyerUserId: this.$route.query.couponsBuyerUserId
      //                   },
      //               });
      this.$router.go(-1);
    },
    updateMobile() {
      this.$push({
        path: "/updateMobile",
        query: { phone: this.userPhone },
      });
    },
  },
};
</script>

<style scoped lang="less">
// .orders {
//   background: linear-gradient(
//     180deg,
//     var(--depYelColor) 70px,
//     var(--bgColor) 0
//   );
//   .pageFlexBetween {
//     color: #fff;
//     .title {
//       margin-top: 20px;
//       margin-bottom: 16px;
//       font-size: 24px;
//     }
//     .iconsearch {
//       font-size: 36px;
//       margin-top: 5px;
//     }
//   }
//   /deep/ .van-tabs__wrap {
//     height: 50px;
//     border-radius: 5px;
//     box-shadow: 0px 0px 10px rgba(170, 170, 170, 0.349);
//     .van-tab {
//       font-size: 14px;
//       color: #666;
//       // border-right: 1px solid var(--lineColor);
//       box-shadow: 0px 0px 3px 0.1px var(--lineColor);
//       .van-info {
//         right: -10px;
//         background-color: var(--depYelColor);
//       }
//       /deep/.van-tabs__line {
//         border-radius: 0;
//       }
//       // box-shadow: 0px 0px 3px 0.1px #999;
//     }
//   }
// }
.index {
  margin: 20px;

  .top {
    background: linear-gradient(90deg, #f0bc2d, #d9cb00);
    color: #2e2809;
    padding: -20px;
    margin: -20px;
    height: 130px;

    div {
      padding: 30px 20px 20px 20px;

      .phone {
        color: #2e2809;
      }

      .label {
        font-weight: 700;
        font-size: 22px;
        width: 65%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .vip {
      font-size: 80px;
      font-weight: bold;
      color: #666;
      margin-top: -130px;
      text-align: right;
    }
  }

  .topbutton {
    display: flex;
    justify-content: space-between;
    margin-top: 3px;

    .left {
      .disable {
        color: #ccc;
      }
    }

    .van-button {
      height: 30px;
      margin-right: 10px;
      font-weight: bold;
      color: #f7b603;
      box-shadow: #3232332e 0 0 15px;
    }
    /deep/ .van-button--normal {
      padding: 0 10px;
    }

    .right {
      background: #fff;
      padding: 5px 10px;
      border-radius: 20px;
      box-shadow: #3232332e 0 0 15px;

      div {
        display: flex;
        align-items: center;

        i {
          font-size: 18px;
          margin-right: 5px;
          font-weight: bold;
          border-radius: 50%;
          color: red;
        }
      }
    }
  }
}
.orderList {
  // position: relative;
  .itemModal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 20px;
    z-index: 1003;
    .isModal {
      margin-top: -100px;
    }
  }
  .radios {
    background: #fff;
    color: var(--redColor);
    font-size: 14px;
    width: 42px;
    height: 42px;
    margin-top: 5px;
    text-align: center;
  }
  @themeColor: #fff;
  .listItem {
    padding: 0;
    margin-top: 15px;
    min-height: 90px;
    font-size: var(--pFont);
    .title {
      height: 40px;
      font-size: var(--titleFont);
      color: var(--titleColor);
      p {
        margin-left: 24%;
      }
      span {
        color: var(--redColor);
        margin-right: 13px;
      }
    }
    .line {
      height: 5px;
      margin: 0 2px;
      margin-top: -5px;
      box-shadow: 0px 4px 4px 2px #f4f4f4;
    }
    .icons {
      width: 19%;
      float: left;
      color: #666;
      margin: -25px 0 0 10px;
      .pageBgBlock {
        color: #fff;
        width: 50px;
        height: 50px;
        background: var(--redColor);
        .iconfont {
          font-size: 28px;
          margin: 4px 10px;
        }
      }
      p {
        margin-top: 15px;
        padding: 5px 8px;
        font-size: var(--spanFont);
        color: var(--depBlueColor);
        background: #e0f4fd;
      }
    }
    .unPay {
      p {
        color: var(--greenColor);
        background: #eef6e0;
      }
    }
    .processing {
      p {
        background: #fdecd5;
        color: var(--depYelColor);
      }
    }
    .detail {
      padding: 12px 0;
      margin-left: 24%;
      span {
        font-size: var(--smallFont);
        color: var(--hidColor);
        display: inline-block;
        line-height: 1.5;
      }
      .remark {
        margin-top: 4px;
        padding-top: 3px;
        font-size: var(--pFont);
        border-top: 1px solid var(--lineColor);
        color: var(--hidColor);
      }
      h5 {
        margin-top: 6px;
        color: var(--depBlueColor);
      }
    }
    .btnGroud {
      .pageSmallBtns {
        width: 50%;
        height: 35px;
        border-radius: 0px;
      }
      .cancel {
        color: var(--depHidColor) !important;
      }
    }
    .footer {
      color: #fff;
      background: var(--depBlueColor);
      height: 35px;
      padding: 0 15px;
      box-sizing: border-box;
      p {
        flex: 1;
      }
      .pageSmallBtns {
        color: var(--depBlueColor) !important;
        border-radius: 5px;
        font-size: var(--spanFont);
        height: 24px;
      }
    }
  }
  // .isUsed {
  //   background: var(--bgColor);
  //   position: relative;
  //   &::after {
  //     content: "";
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     right: 0;
  //     bottom: 0;
  //     background: rgba(249, 249, 249, 0.5);
  //   }
  // }
}
</style>
